import React from "react";
import {
  Box,
  Stack,
  Chip,
  Card,
  CardContent,
  Typography,
  CardActionArea,
  Rating,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  formatCalendarDate,
  getContentOptions,
  getYear,
  // reactionOptions
} from "../../utils/utils.js";

/**
 * One finished entry as a row in Track's list view: title (and year), with the
 * entry's finish date and rating on the right.
 *
 * @param {boolean} [showType] - Lead the title with the content type's icon,
 *   for the All tab, where types are mixed
 * @param {boolean} [hideYear] - Leave the year off the finish date, when a
 *   month heading above already gives it (grouped by finish date)
 */
function JournalList({ item, onClick, showType = false, hideYear = false }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  if (!item) return null;
  const {
    content_title,
    content_date,
    content_type,
    date,
    rating,
    // reactions
  } = item;

  const content_date_fixed =
    content_type === "book" ? content_date : getYear(content_date);

  return (
    <Card onClick={onClick} elevation={0} width="100%">
      <CardActionArea>
        <CardContent
          sx={{
            display: "flex",
            justifyContent: "space-between",
            p: "0px 4px",
            width: "100%",
          }}
        >
          <Stack
            direction="row"
            spacing={2}
            justifyContent={"flex-start"}
            alignItems={"center"}
            sx={{ flex: 1, minWidth: 0 }}
          >
            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
              sx={{ minWidth: 0 }}
            >
              {showType && getContentOptions()[content_type] && (
                <Box
                  component="span"
                  sx={{
                    display: "flex",
                    flexShrink: 0,
                    color: "text.secondary",
                    "& svg": { fontSize: isMobile ? 18 : 22 },
                  }}
                >
                  {getContentOptions()[content_type].icon}
                </Box>
              )}
              <Typography
                variant={isMobile ? "body1" : "h6"}
                sx={{
                  fontWeight: "bold",
                  minWidth: 0,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {content_title}
              </Typography>
            </Stack>
            <Typography
              variant="subtitle1"
              color="text.secondary"
              sx={{
                fontStyle: "italic",
                display: { xs: "none", sm: "inline-flex" },
                pr: 1,
              }}
            >
              {content_date_fixed}
            </Typography>
          </Stack>
          <Stack
            direction="row"
            spacing={1}
            justifyContent={"flex-end"}
            alignItems="center"
          >
            <Chip
              label={
                !date
                  ? "Undated"
                  : hideYear
                  ? formatCalendarDate(date, "dropYear")
                  : isMobile
                  ? formatCalendarDate(date, "shortYear")
                  : formatCalendarDate(date)
              }
              size="small"
              sx={{
                backgroundColor: "transparent",
                color: "text.secondary",
                display: "inline-flex",
              }}
            />

            {/* {reactions &&
              reactions.slice(0, 4).map((reaction, index) => {
                const option = reactionOptions.find(
                  (option) => option.label === reaction
                );
                return (
                  <Chip
                    key={index}
                    icon={
                      option.icon || (
                        <span role="img" aria-label={option.label}>
                          {option.emoji}
                        </span>
                      )
                    }
                    label={reaction}
                    size="small"
                    sx={{
                      mr: 1,
                      display: { xs: "none", lg: "inline-flex" },
                    }}
                  />
                );
              })}

            {reactions && reactions.length > 4 && (
              <Chip
                label={`+${reactions.length - 4}`}
                size="small"
                sx={{
                  mr: 1,
                  display: { xs: "none", lg: "inline-flex" },
                }}
              />
            )} */}

            <Rating
              value={rating}
              readOnly
              precision={0.5}
              size={isMobile ? "small" : "medium"}
            />
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}

export default JournalList;
